import '@fontsource/roboto/latin.css';
import { Amplify } from 'aws-amplify';
// import CognitoConfig from 'components/Cognito';
import GoogleTagManager from 'components/GoogleTagManager';
import PageFooter from 'components/PageFooter';
import cognitoConfig from 'lib/auth/cognito-config';
import { AppProps } from 'next/app';
import { RecoilRoot } from 'recoil';
import styled from 'styled-components';
import { ThemeProvider } from 'styled-components';
import 'styles/Calendar/calendar-override.css';
import 'styles/Calendar/mobiscroll.react.min.css';
import 'styles/globals.css';
import primaryTheme from 'styles/themes/primary.json';

import { I18nProvider } from '../locales';
import en from '../locales/en';

Amplify.configure(cognitoConfig, { ssr: true });

const MainContainer = styled.main`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
`;

const Container = styled.div`
	flex: 1;
	margin: auto;
	padding: 0 16px 0 16px;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	@media (min-width: ${(props) => props.theme.breakpoints.medium}) {
	}
	@media (min-width: ${(props) => props.theme.breakpoints.large}) {
		max-width: 960px;
	}
	@media (min-width: ${(props) => props.theme.breakpoints.x_large}) {
		max-width: 1140px;
	}
	@media (min-width: ${(props) => props.theme.breakpoints.xx_large}) {
		max-width: 1360px;
	}
	@media (min-width: 1440px) {
		max-width: 1360px;
		padding: 0 32px;
	}
`;

const FooterContainer = styled.footer`
	width: 100%;

	@media (min-width: ${(props) => props.theme.breakpoints.medium}) {
		margin-top: auto;
	}

	@media (max-width: 440px) {
		flex-direction: column;
	}

	@media (min-width: ${(props) => props.theme.breakpoints.large}) {
		max-width: 960px;
	}
	@media (min-width: ${(props) => props.theme.breakpoints.x_large}) {
		max-width: 1140px;
	}
	@media (min-width: ${(props) => props.theme.breakpoints.xx_large}) {
		max-width: 1360px;
	}
	@media (min-width: 1440px) {
		max-width: 1360px;
		padding: 0 32px;
	}
`;

const MyApp = ({ Component, pageProps }: AppProps) => {
	return (
		<I18nProvider
			locale={pageProps.locale}
			fallback={<p>Loading initial locale client-side</p>}
			fallbackLocale={en}
		>
			<RecoilRoot>
				{/* <CognitoConfig /> */}
				<GoogleTagManager>
					<ThemeProvider theme={primaryTheme}>
						<MainContainer>
							<Container>
								<Component {...pageProps} />
								<FooterContainer>
									<PageFooter />
								</FooterContainer>
							</Container>
						</MainContainer>
					</ThemeProvider>
				</GoogleTagManager>
			</RecoilRoot>
		</I18nProvider>
	);
};

export default MyApp;
